import * as actionTypes from "./actionTypes";

const initialState = {
    terminalsListByEntityId: {
        // [entityId] : [{label: terminal_1, value: terminal_1}]
    },
    interfacesListByEntityId: {
        // [entityId] : [{label: entityInterface_1, value: entityInterface_1}]
    },
    interfacesListByTerminalId: {
        // [terminalId] : [{label: terminalInterface_1, value: terminalInterface_1}]
    }
};

const chartConfigsReducer = (state = initialState, payload) => {
    switch (payload.type) {
        case actionTypes.FETCH_TERMINALS_OF_ENTITY_REQUEST:
            return {
                ...state,
                terminalsListByEntityId: {
                    ...state.terminalsListByEntityId,
                    [payload.entityId]: []
                }
            };
        case actionTypes.FETCH_TERMINALS_OF_ENTITY_SUCCESS:
            return {
                ...state,
                terminalsListByEntityId: {
                    ...state.terminalsListByEntityId,
                    [payload.entityId]: payload.terminalList
                }
            };
        case actionTypes.FETCH_INTERFACES_OF_ENTITY_REQUEST:
            return {
                ...state,
                interfacesListByEntityId: {
                    ...state.interfacesListByEntityId,
                    [payload.entityId]: []
                }
            };
        case actionTypes.FETCH_INTERFACES_OF_ENTITY_SUCCESS:
            return {
                ...state,
                interfacesListByEntityId: {
                    ...state.interfacesListByEntityId,
                    [payload.entityId]: payload.interfaceList
                }
            };
        case actionTypes.FETCH_INTERFACES_OF_TERMINAL_REQUEST:
            return {
                ...state,
                interfacesListByTerminalId: {
                    ...state.interfacesListByTerminalId,
                    [payload.terminalId]: []
                }
            };
        case actionTypes.FETCH_INTERFACES_OF_TERMINAL_SUCCESS:
            return {
                ...state,
                interfacesListByTerminalId: {
                    ...state.interfacesListByTerminalId,
                    [payload.terminalId]: payload.interfaceList
                }
            };
        case actionTypes.FETCH_TERMINALS_OF_ENTITY_FAILED:
        case actionTypes.FETCH_INTERFACES_OF_ENTITY_FAILED:
        case actionTypes.FETCH_INTERFACES_OF_TERMINAL_FAILED:
        default:
            return state;
    }
};


export default chartConfigsReducer;
